import { routes } from 'commons/constants/routes'
import { Link } from 'ui/components'
import { Button } from 'ui/components/Buttons'

import { useTemplatesDetailsContext } from '../context'

import * as SC from './styles'

export const Footer = () => {
  const { data } = useTemplatesDetailsContext()
  const { id } = data

  return (
    <SC.Box>
      <Link to={routes.bank.documentTemplates.manage} params={{ id: id.toString() }}>
        <Button face="primary" data-qa="Edit">
          Edit
        </Button>
      </Link>
    </SC.Box>
  )
}
